import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Properties from "@/pages/Properties";
import Business from "@/pages/Business";
import Hurricane from "@/pages/Hurricane";
import Companies from "@/pages/Companies";
import Quote from "@/pages/Quote";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import AccessibilityStatement from "@/pages/AccessibilityStatement";

let lenisInstance = null;

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    lenisInstance = lenis;
    return () => {
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/business" element={<Business />} />
            <Route path="/hurricane" element={<Hurricane />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
          <Route path="/about-us" element={<Navigate to="/about" replace />} />
          <Route path="/copy-of-about-us" element={<Navigate to="/hurricane" replace />} />
          <Route path="*" element={<Layout />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
